import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type RequestTosAcceptanceMutationVariables = Types.Exact<{
  ownerId: Types.Scalars['Int']
  accepterId: Types.Scalars['Int']
}>

export type RequestTosAcceptanceMutation = {
  __typename?: 'Mutation'
  requestAcceptance?: {
    __typename?: 'RequestAcceptancePayload'
    acceptance?: {
      __typename?: 'Acceptance'
      id: number
      signedDocument?: { __typename?: 'File'; url?: string | null } | null
    } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const RequestTosAcceptanceDocument = `
    mutation RequestTosAcceptance($ownerId: Int!, $accepterId: Int!) {
  requestAcceptance(
    input: {ownerId: $ownerId, accepterId: $accepterId, type: "pth_organization_tos"}
  ) {
    acceptance {
      id
      signedDocument {
        url
      }
    }
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useRequestTosAcceptanceMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    RequestTosAcceptanceMutation,
    TError,
    RequestTosAcceptanceMutationVariables,
    TContext
  >
) =>
  useMutation<RequestTosAcceptanceMutation, TError, RequestTosAcceptanceMutationVariables, TContext>(
    ['RequestTosAcceptance'],
    (variables?: RequestTosAcceptanceMutationVariables) =>
      fetchGql<RequestTosAcceptanceMutation, RequestTosAcceptanceMutationVariables>(
        RequestTosAcceptanceDocument,
        variables
      )(),
    options
  )
